"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.CustomerCourierContactOrigin=void 0;var r;(function(e){e.Chat="chat",e.Help="help",e.Home="home",e.Orders="orders"})(r||(exports.CustomerCourierContactOrigin=r={}));
//# sourceMappingURL=CustomerCourierContactOrigin.js.map
